module.exports = __webpack_public_path__ + "img/chess-default-header.858dccdf.png";